import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IApiModel } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ApiHelperService {
  static setFormError(form: FormGroup, result: IApiModel): void {
    if (result?.data) {
      console.log(result.data);
      Object.keys(result.data).forEach((key) => {
        const field = key === '$all' ? form : form.get(key);
        const value = result.data[key];
        const errors: any = {};
        if (value instanceof Array) {
          console.log(value);
          for (const error of value) {
            errors[error] = true;
          }
        } else {
          console.log(value);
          errors[value] = true;
        }
        if (errors) {
          field?.setErrors(errors);
          field?.markAsTouched();
        }
      });
    }
  }
}
